// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const UG_PHONE_REGEX = /^\+256 (?!256)\d{8,12}$/;

export function validateUgandaPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!UG_PHONE_REGEX.test(phoneNumberValue) || phoneNumberValue.length < 13) {
    return { id: 'invalid-pattern' };
  }
}
